import React, { useEffect, useRef } from "react";

/**
 * Accessible dialog: closes on Escape, on backdrop click and on the close
 * button, restores focus to whatever opened it, and traps nothing else so
 * screen readers can still reach the heading.
 */
function Modal({ isOpen, onClose, title, children }) {
  const closeRef = useRef(null);
  const openerRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    openerRef.current = document.activeElement;
    closeRef.current?.focus();

    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previousOverflow;
      if (openerRef.current instanceof HTMLElement) openerRef.current.focus();
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="ovl"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={onClose}
    >
      <div className="dlg" onClick={(e) => e.stopPropagation()}>
        <div className="dlg-hd">
          <h3>{title}</h3>
          <button type="button" ref={closeRef} className="x" onClick={onClose} aria-label="Close dialog">
            ✕
          </button>
        </div>
        <div className="dlg-bd">{children}</div>
      </div>
    </div>
  );
}

export default Modal;
